<template>
  <div>
    <app-header />
    <hr />
    <b-overlay v-if="waitingLoadChart" id="overlay-background" class="overlay-config calendar-seasonal loading" :show="waiting" rounded="sm" >
      <section class="graph-container">
        <areas-graph />
        <indicators-graph />
        <footer-graph />
      </section>
    </b-overlay>
    <div class="" v-else>
      <h1 class="clockText">{{ $t('selecione-um-periodo') }}</h1>
      <img
        src="@/assets/Monitoramento.png"
        class="iconPermission"
        :alt="$t('selecione-um-periodo')"
        :title="$t('selecione-um-periodo')"
      />
    </div>
  </div>
</template>

<script>
import AdherenceIndicatorsHeader from "../productionMonitoring/template/AdherenceIndicatorsHeader.vue";
import AdherenceIndicatorsGraph1 from "../productionMonitoring/template/AdherenceIndicatorsGraph1.vue";
import AdherenceIndicatorsGraph2 from "../productionMonitoring/template/AdherenceIndicatorsGraph2.vue";
import AdherenceIndicatorsFooter from "../productionMonitoring/template/AdherenceIndicatorsFooter.vue";
import Mediator from "./utilites/Mediator";
import axios from "axios";
import { urlMainAPI } from "@/global";

export default {
  name: "AdherenceIndicators",
  components: {
    "app-header": AdherenceIndicatorsHeader,
    "areas-graph": AdherenceIndicatorsGraph1,
    "indicators-graph": AdherenceIndicatorsGraph2,
    "footer-graph": AdherenceIndicatorsFooter,
  },

  data() {
    return {
      name: "AdherenceIndicators",
      status: 0,
      waiting: true,
      waitingLoadChart: false,
    };
  },

  methods: {
    async getAllAdherenceIndicators(parameterSearch) {
      this.waitingLoadChart = true
      const url = `${urlMainAPI}/getadherencedailysearch/${parameterSearch.area}/${parameterSearch.dateInitial}/${parameterSearch.dateFinal}/${parameterSearch.shift}/${this.$route.params.unitId}`;
      await axios
        .get(url)
        .then(async (res) => {
          this.res = res.status;
          if (this.res == 200) {
            await Mediator.notify(res.data, "loading-infos");
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.waiting = false;
    },
  },
  async mounted() {
    await Mediator.notify(this, "init");
  },
};
</script>

<style scoped>
hr {
  margin: 7px;
}

.graph-container{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.loading {
  display: block;
}
.iconPermission {
  position: absolute;
  width: 300px;
  top: Calc(50% - 158px);
  left: Calc(50% - 158px);
  opacity: 0.1;
}
.clockText {
  position: absolute;
  top: 50%;
  text-align: center;
  width: 99%;
  font-size: 1.5rem;
}

</style>